import React from 'react';

export default props => (
  <div className="ant-form-explain" {...props} />
);
